import React, { useEffect, useState } from 'react'

const HeroRexLogo = () => {
  const [showLogo, setShowLogo] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setShowLogo(true), 50)
    return () => clearTimeout(timer)
  }, [])
  return (
    <img
      src="/website/hero_rex.svg"
      alt="Resilience Explorer®"
      className={`
            pointer-events-none
            absolute inset-0 m-auto
            w-[80%] max-w-[48rem]
            z-20
            transition-all
            duration-[1800ms]
            ease-[cubic-bezier(0.22,1,0.36,1)]
            ${showLogo ? 'opacity-80 scale-100' : 'opacity-0 scale-75'}
          `}
    />
  )
}

export default HeroRexLogo
